import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { T } from '../../lib/i18n';
import { fmt, badge, riskColor, riskWord, zebra } from '../../lib/format';
import { cardPad, Th } from '../../lib/ui';

export default function Rfq() {
  const { state, go, L } = useApp();
  const t = T(state.lang);

  const rfqs = [
    { id: 'RFQ-2026-001', title: 'Fleet Vehicle Insurance — Class 1 Batch', owner: 'Maria B. · Procurement', category: 'Vehicle Insurance', method: 'e-Bidding', value: 4850000, deadline: '2026-06-20', status: 'Sent', risk: 12, bids: 3 },
    { id: 'RFQ-2026-002', title: 'Spare Parts Procurement — Quarterly Q2', owner: 'Sam K. · Procurement', category: 'Automotive Parts', method: 'e-Auction', value: 12400000, deadline: '2026-06-15', status: 'Closed', risk: 41, bids: 5 },
    { id: 'RFQ-2026-004', title: 'Fleet Vehicle Insurance — Class 2 & 3', owner: 'Maria B. · Procurement', category: 'Vehicle Insurance', method: 'e-Bidding', value: 7200000, deadline: '2026-06-28', status: 'Sent', risk: 72, bids: 2 },
    { id: 'RFQ-2026-005', title: 'Maintenance Services — Factory Equipment', owner: 'Paula W. · Procurement', category: 'Services', method: 'Price Comparison', value: 2100000, deadline: '2026-06-10', status: 'Awarded', risk: 18, bids: 3 },
  ];
  const rfqRows = rfqs.map((r, i) => {
    const b = badge(r.status);
    return {
      ...r,
      value: fmt(r.value),
      zebra: zebra(i),
      stBg: b.bg,
      stFg: b.fg,
      riskColor: riskColor(r.risk),
      riskText: r.risk + ' · ' + riskWord(r.risk),
      bidsBtn: L('Bids', 'ข้อเสนอราคา') + ' (' + r.bids + ')',
      onBids: () => go('bidcompare'),
    };
  });
  const rfqFooter = L('Showing 4 of 6 RFQs · Total value: $26.5M', 'แสดง 4 จาก 6 RFQ · มูลค่ารวม: $26.5M');

  return (
    <>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 320 }}>
          <Icon name="search" style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--color-fg-3)', fontSize: 16 }} />
          <input placeholder={t.searchRfq} style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }} />
        </div>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{t.allStatus}</option>
          <option>{L('Sent', 'ส่งแล้ว')}</option>
          <option>{L('Closed', 'ปิดแล้ว')}</option>
          <option>{L('Awarded', 'มอบสัญญาแล้ว')}</option>
          <option>{L('Draft', 'ฉบับร่าง')}</option>
        </select>
        <select style={{ padding: '9px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>
          <option>{t.allCategories}</option>
          <option>{L('Vehicle Insurance', 'ประกันภัยรถยนต์')}</option>
          <option>{L('Insurance', 'ประกันภัย')}</option>
          <option>{L('Automotive Parts', 'อะไหล่ยานยนต์')}</option>
          <option>{L('Services', 'บริการ')}</option>
        </select>
        <div style={{ flex: 1 }} />
        <button className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '9px 14px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 13, fontWeight: 600, background: 'var(--color-white)' }}>
          <Icon name="download" />{t.export}
        </button>
      </div>
      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('RFQ No', 'เลขที่ RFQ')}</Th>
              <Th>{L('Title', 'หัวข้อ')}</Th>
              <Th>{L('Category', 'หมวดหมู่')}</Th>
              <Th>{L('Method', 'วิธีการ')}</Th>
              <Th align="right">{L('Value (USD)', 'มูลค่า (USD)')}</Th>
              <Th>{L('Deadline', 'กำหนดส่ง')}</Th>
              <Th>{L('Status', 'สถานะ')}</Th>
              <Th>{L('Collusion Risk', 'ความเสี่ยงสมรู้ร่วมคิด')}</Th>
              <Th align="right">{L('Actions', 'การดำเนินการ')}</Th>
            </tr>
          </thead>
          <tbody>
            {rfqRows.map((r) => (
              <tr key={r.id} style={{ borderBottom: '1px solid var(--color-border)', background: r.zebra }}>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.id}</td>
                <td style={{ padding: '12px 14px' }}>
                  <div style={{ fontWeight: 600 }}>{r.title}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{r.owner}</div>
                </td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)' }}>{r.category}</span>
                </td>
                <td style={{ padding: '12px 14px', color: 'var(--color-fg-2)' }}>{r.method}</td>
                <td style={{ padding: '12px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.value}</td>
                <td style={{ padding: '12px 14px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{r.deadline}</td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: r.stBg, color: r.stFg }}>
                    <span style={{ width: 6, height: 6, borderRadius: 999, background: r.stFg }} />{r.status}
                  </span>
                </td>
                <td style={{ padding: '12px 14px' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12, fontWeight: 600, color: r.riskColor }}>
                    <span style={{ width: 8, height: 8, borderRadius: 999, background: r.riskColor }} />
                    <span style={{ fontFamily: 'var(--font-mono)' }}>{r.riskText}</span>
                  </span>
                </td>
                <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                  <button onClick={r.onBids} className="hv-blue" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-blue)', color: '#fff' }}>{r.bidsBtn}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding: '12px 16px', fontSize: 12, color: 'var(--color-fg-3)', borderTop: '1px solid var(--color-border)' }}>{rfqFooter}</div>
      </div>
    </>
  );
}
